import { Box, Typography } from '@mui/material';
import { PageBase } from '../../PageBase';
import { theme } from '@/styles/theme';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const Telemedicine = () => {
  const { t } = useTranslation('telemedicine');
  const navigate = useNavigate();

  return (
    <PageBase title={t('Termos de uso')} onBackClick={() => navigate(-1)} paddingInline={0}>
      <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 4 }}>
        <Box>
          <Typography
            sx={{
              fontSize: '1.8rem',
              fontWeight: 600,
              color: theme.palette.primary.main,
            }}
          >
            {t('title')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('description')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.0rem',
              fontWeight: 400,
            }}
          >
            {t('last_updated')}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('presection_description')}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: 3.3 }}>
        <Typography
          sx={{
            fontSize: '1.4rem',
            fontWeight: 600,
          }}
        >
          {t('section1')}
        </Typography>
        <Box sx={{ marginTop: 1.0 }}>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section1_description')}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: 3.3 }}>
        <Typography
          sx={{
            fontSize: '1.4rem',
            fontWeight: 600,
          }}
        >
          {t('section2')}
        </Typography>
        <Box sx={{ marginTop: 1.0 }}>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section2_description1')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section2_description2')}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: 3.3 }}>
        <Typography
          sx={{
            fontSize: '1.4rem',
            fontWeight: 600,
          }}
        >
          {t('section3')}
        </Typography>
        <Box sx={{ marginTop: 1.0 }}>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section3_description1')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section3_description2')}
          </Typography>
        </Box>
        <Box sx={{ marginTop: 1.0, marginLeft: 3.0 }}>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section3_description2_sub1')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section3_description2_sub2')}
          </Typography>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section3_description2_sub3')}
          </Typography>
        </Box>
        <Box sx={{ marginTop: 1.0 }}>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 400,
            }}
          >
            {t('section3_description3')}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: 3.3 }}>
          <Typography
            sx={{
              fontSize: '1.4rem',
              fontWeight: 600,
            }}
          >
            {t('section4')}
          </Typography>
          <Box sx={{ marginTop: 1.0 }}>
            <Typography
              sx={{
                fontSize: '1.4rem',
                fontWeight: 400,
              }}
            >
              {t('section4_description1')}
            </Typography>
            <Typography
              sx={{
                fontSize: '1.4rem',
                fontWeight: 400,
              }}
            >
              {t('section4_description2')}
            </Typography>
            <Typography
              sx={{
                fontSize: '1.4rem',
                fontWeight: 400,
              }}
            >
              {t('section4_description3')}
            </Typography>
          </Box>
        </Box>
      </Box>
    </PageBase>
  );
};
